(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["imagenes-review"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Re-init friendly: works in theme editor when sections re-render.
  function initAllSimpleSliders(context) {
    context = context || document;
    var sliders = context.querySelectorAll('.sm-slider');
    sliders.forEach(initSimpleSlider);
  }

  function initSimpleSlider(slider) {
    if (!slider) return;
    if (slider.dataset.smInit === 'true') return; // ya inicializado

    var viewport = slider.querySelector('.sm-slider__viewport');
    var track = slider.querySelector('.sm-slider__track');
    var slides = slider.querySelectorAll('.sm-slide');
    var btnPrev = slider.querySelector('.sm-slider__btn--prev');
    var btnNext = slider.querySelector('.sm-slider__btn--next');

    var desktopCols = parseInt(slider.dataset.columnsDesktop) || 4;
    var mobileCols = parseInt(slider.dataset.columnsMobile) || 1;

    // calcula columnas segun tamaño actual
    function currentCols() {
      return window.innerWidth < 768 ? mobileCols : desktopCols;
    }

    // si no hay imágenes o hay menos slides que columnas, ocultar flechas
    function updateArrowsVisibility() {
      var cols = currentCols();
      var total = slides.length;
      if (total <= cols) {
        slider.classList.add('sm-slider--no-arrows');
      } else {
        slider.classList.remove('sm-slider--no-arrows');
      }
    }

    // scroll amount: ancho 1 slide * cols
    function computeScrollAmount() {
      if (!slides[0]) return viewport.clientWidth;
      var rect = slides[0].getBoundingClientRect();
      var slideWidth = rect.width;
      var cols = currentCols();
      return Math.round(slideWidth * cols);
    }

    // handlers
    function onNext() {
      var amount = computeScrollAmount();
      viewport.scrollBy({ left: amount, behavior: 'smooth' });
    }
    function onPrev() {
      var amount = computeScrollAmount();
      viewport.scrollBy({ left: -amount, behavior: 'smooth' });
    }

    function updateButtonsState() {
      // desactivar si inicio o final
      if (!btnPrev || !btnNext) return;
      var maxScrollLeft = track.scrollWidth - viewport.clientWidth;
      if (viewport.scrollLeft <= 5) {
        btnPrev.disabled = true;
      } else {
        btnPrev.disabled = false;
      }
      if (viewport.scrollLeft >= maxScrollLeft - 5) {
        btnNext.disabled = true;
      } else {
        btnNext.disabled = false;
      }
    }

    // events
    btnNext && btnNext.addEventListener('click', onNext);
    btnPrev && btnPrev.addEventListener('click', onPrev);

    viewport.addEventListener('scroll', function () {
      // actualizar estado botones con throttle ligero
      window.requestAnimationFrame(updateButtonsState);
    });

    // re-calc on resize
    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateArrowsVisibility();
        updateButtonsState();
      }, 120);
    }
    window.addEventListener('resize', onResize);

    // inicializar estados
    updateArrowsVisibility();
    updateButtonsState();

    // marcar inicializado para evitar dobles bindings tras re-render en editor
    slider.dataset.smInit = 'true';

    // re-init si el contenido DOM del slider cambia (p. ej. al guardar en el editor)
    var mo = new MutationObserver(function (mutations) {
      // si cambió la cantidad de slides, resetear visibilidad y botones
      var changed = mutations.some(function (m) {
        return m.type === 'childList';
      });
      if (changed) {
        slides = slider.querySelectorAll('.sm-slide');
        updateArrowsVisibility();
        updateButtonsState();
      }
    });
    mo.observe(track, { childList: true });
  }

  // init on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    initAllSimpleSliders(document);
  });

  // Shopify theme editor fires this when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt && evt.target) {
      initAllSimpleSliders(evt.target);
    } else {
      initAllSimpleSliders(document);
    }
  });

  // Also init when blocks or sections are selected/updated in editor (fallbacks)
  document.addEventListener('shopify:block:select', function (evt) { initAllSimpleSliders(document); });
  document.addEventListener('shopify:section:reorder', function (evt) { initAllSimpleSliders(document); });
})();

  } catch(e) { console.error(e); }
})();
})();
